export default "__VITE_ASSET__WdT94Zrz__"